<template>
  <div class="container">
    <div class="handle-box">
      <el-form ref="queryCondition" label-width="120px" :model="queryCondition" class="searchForm">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('apply.no')" prop="calculateNo">
              <el-input class="handle-input" v-model="queryCondition.calculateNo" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.remarks')" prop="remark">
              <el-input class="handle-input" v-model="queryCondition.remark" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="mini" type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
          <el-button size="mini" type="primary" @click="restQueryForm('queryCondition')">{{$t('common.reset')}}</el-button>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" type="primary" v-acl="CalculatesAdd" @click="showDetail(-1)">{{$t('common.addNew')}}</el-button>
    </div>
    <el-table :data="tableData" ref="tableData" border height='470' highlight-current-row>
      <el-table-column show-overflow-tooltip sortable prop="calculateNo" :label="$t('apply.no')" min-width="120px" fixed>
        <template slot-scope="scope">
          <div @click="showDetail(scope.row.ttCalculateId)" class="a-link">{{scope.row.calculateNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="remark" :label="$t('common.remarks')" min-width="120px"></el-table-column><!-- 备注 -->
      <el-table-column show-overflow-tooltip sortable prop="creator" :label="$t('common.updateBy')" min-width="120px"></el-table-column><!-- 修改人 -->
      <el-table-column show-overflow-tooltip sortable prop="updateDate" :label="$t('common.updateDate')" min-width="120px">
        <template slot-scope="scope">
          {{scope.row.updateDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { calculates } from "@/api/quoteByProduct.js";
import commonFunction from "@/utils/dataTableUtils"
export default {
  name: "count",
  data() {
    return {
      totalCount: 0,
      queryCondition: {
        calculateNo: "",
        remark: "",
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
      },
      tableData: [],
    };
  },
  created() {
    this.queryData(1);
  },
  methods: {
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      calculates(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    //查询条件重置方法
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
    },
    showDetail(id) {
      let that = this;
      this.$router.push({
        path: `/count-datail`,
        query: {
          ttCalculateId: id,
        }
      });
    },
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.listBox {
  .toolsBox {
    margin-bottom: 10px;
  }
}
</style>
